import { render, staticRenderFns } from "./shootTest.vue?vue&type=template&id=c0baabb0&scoped=true&"
import script from "./shootTest.vue?vue&type=script&lang=js&"
export * from "./shootTest.vue?vue&type=script&lang=js&"
import style0 from "./shootTest.vue?vue&type=style&index=0&id=c0baabb0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0baabb0",
  null
  
)

export default component.exports